import {
    DeviceInfoInputRow,
    INIT_DEVICE_INFO_INPUT_ROW,
    EstimateInquiry,
    ESTIMATE_DETAIL_INIT,
} from '../../types/common/EstimateInquiryType';

import {
    setState as setDeviceListStore,
    deleteDeviceRow as deleteDeviceRowStore,
} from '../../slice/EstimateInquirySlice';
import { AppDispatch } from '../../store/store';

// 編集行のstate更新
const setStateDeviceRowValue = (
    dispatch: AppDispatch,
    estimateInquiry: EstimateInquiry,
    changedRowValue: DeviceInfoInputRow
) => {
    const changedDeviceList = estimateInquiry.deviceList.map((deviceInfoRow) => {
        // 変更機器行の検出
        if (changedRowValue.deviceRowNumber === deviceInfoRow.deviceRowNumber) {
            const editRow = deviceInfoRow.inputList.map((inputRow) => {
                // 変更編集行の検出
                if (inputRow.inputRowNumber === changedRowValue.inputRowNumber) {
                    return changedRowValue;
                } else {
                    return inputRow;
                }
            });
            // 変更内容の返却
            const ret = { ...deviceInfoRow, inputList: editRow };
            return ret;
        } else {
            // 変更がない機器行の返却
            return deviceInfoRow;
        }
    });
    const changedEstimateInquiry = {
        ...estimateInquiry,
        deviceList: changedDeviceList,
    };
    dispatch(setDeviceListStore(changedEstimateInquiry));
};

// 編集行追加
const addEditRow = (dispatch: AppDispatch, deviceRowNumber: number, estimateInquiry: EstimateInquiry) => {
    const newInputList: DeviceInfoInputRow[] = [];
    const changedDeviceList = estimateInquiry.deviceList.map((deviceRow) => {
        if (deviceRow.deviceRowNumber === deviceRowNumber) {
            // 最大値＋1を次の入力番号として採番
            const nextInputRowNumber = Math.max(...deviceRow.inputList.map((row) => row.inputRowNumber ?? 0)) + 1;
            // 編集行を追加
            const addRowList: Array<DeviceInfoInputRow> = [
                ...deviceRow.inputList,
                {
                    ...INIT_DEVICE_INFO_INPUT_ROW,
                    deviceRowNumber: deviceRowNumber,
                    inputRowNumber: nextInputRowNumber,
                },
            ];
            // 編集した行を返却
            deviceRow = {
                ...deviceRow,
                inputList: addRowList,
            };
        }
        // 機器対象を集める
        newInputList.push(...deviceRow.inputList);
        return deviceRow;
    });
    const changedEstimatePatternList = estimateInquiry.estimatePatternList.map((pattern) => {
        const changedEstimateList = newInputList.map((input) => {
            const estimate = pattern.estimateList.find(
                (it) => it.deviceRowNumber === input.deviceRowNumber && it.inputRowNumber === input.inputRowNumber
            );
            if (estimate !== undefined) {
                // 既存データ、そのまま返す
                return estimate;
            } else {
                // 見積条件へ機器詳細を新規追加
                return {
                    ...ESTIMATE_DETAIL_INIT,
                    deviceRowNumber: input.deviceRowNumber ?? 1,
                    inputRowNumber: input.inputRowNumber ?? 1,
                };
            }
        });
        const checkAllFlag = changedEstimateList.find(it => !it.checkFlag) === undefined ? true : false;
        return {
            ...pattern,
            estimateList: changedEstimateList,
            checkAllFlag: checkAllFlag,
        };
    });
    const changedEstimateInquiry = {
        deviceList: changedDeviceList,
        estimatePatternList: changedEstimatePatternList,
    };
    dispatch(setDeviceListStore(changedEstimateInquiry));
};

// 編集行削除
const deleteEditRow = (
    dispatch: AppDispatch,
    deviceRowNumber: number,
    changeRowNum: number,
    estimateInquiry: EstimateInquiry
) => {
    const changedDeviceList = estimateInquiry.deviceList.map((deviceRow) => {
        if (deviceRow.deviceRowNumber === deviceRowNumber) {
            // 行を削除したリストを作成
            const deleteRowList: Array<DeviceInfoInputRow> = deviceRow.inputList.filter(
                (inputRow) => inputRow.inputRowNumber != changeRowNum
            );
            // 編集した行を返却
            return { ...deviceRow, inputList: deleteRowList };
        } else {
            // 編集してない行を返却
            return deviceRow;
        }
    });
    // 見積り条件を更新
    const changedEstimatePatternList = estimateInquiry.estimatePatternList.map((pattern) => {
        const changedEstimateList = pattern.estimateList.filter((it) => {
            return !(it.deviceRowNumber === deviceRowNumber && it.inputRowNumber === changeRowNum);
        });
        let checkAllFlag = pattern.checkAllFlag;
        // 機器対象が0件の場合、全選択を外す
        if(changedEstimateList.length === 0) {
            checkAllFlag = false;
        } else {
            checkAllFlag = changedEstimateList.find(it => !it.checkFlag) === undefined ? true : false;
        }
        return {
            ...pattern,
            estimateList: changedEstimateList,
            checkAllFlag: checkAllFlag,
        };
    });
    const changedEstimateInquiry = {
        deviceList: changedDeviceList,
        estimatePatternList: changedEstimatePatternList,
    };
    dispatch(setDeviceListStore(changedEstimateInquiry));
};

// 機器行の削除
const deleteDeviceRow = (dispatch: AppDispatch, delDeviceRowNumber: number) => {
    dispatch(deleteDeviceRowStore(delDeviceRowNumber)); //deleteRow
};

export const EditDeviceListLogic = {
    setStateDeviceRowValue,
    addEditRow,
    deleteEditRow,
    deleteDeviceRow,
};
